import { axios, AxiosResponse } from "@sdk/axios";
import type {
  iResendEmailConfig,
  iResendDomainDnsRecordsResponse,
  ResendDomainPurpose,
} from "./resend-emails-configurations-models";

export class ResendEmailsConfigurationsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }
  constructor(protected config: { basePath: string; token: string }) {}

  resendEmailsConfigurations = {
    /** Add a sending domain for the current context (brand-aware). */
    addDomain: async (body: {
      domain: string;
      brandId?: string;
      purpose?: ResendDomainPurpose;
    }) => {
      const results: AxiosResponse<{ resendEmailConfig: iResendEmailConfig }> =
        await axios.post(
          this.config.basePath + `/ta-desk/resend/domains`,
          body,
          { headers: { Authorization: this.config.token } }
        );
      return results.data;
    },

    /** Verify the current context's Resend domain (brand-aware). */
    verifyDomain: async (body?: {
      brandId?: string;
      purpose?: ResendDomainPurpose;
    }) => {
      const results: AxiosResponse<{ resendEmailConfig: iResendEmailConfig }> =
        await axios.post(
          this.config.basePath + `/ta-desk/resend/domains/verify`,
          body ?? {},
          { headers: { Authorization: this.config.token } }
        );
      return results.data;
    },

    /** Remove the current context's Resend domain. Requires confirm: true. */
    removeDomain: async (body: {
      confirm: true;
      brandId?: string;
      purpose?: ResendDomainPurpose;
    }) => {
      const results: AxiosResponse<{ removed: true }> = await axios.delete(
        this.config.basePath + `/ta-desk/resend/domains`,
        {
          data: body,
          headers: { Authorization: this.config.token },
        }
      );
      return results.data;
    },

    /** Get DNS records required to verify the current context's Resend domain. */
    getDomainDnsRecords: async (params?: {
      brandId?: string;
      purpose?: ResendDomainPurpose;
    }) => {
      const results: AxiosResponse<iResendDomainDnsRecordsResponse> =
        await axios.get(
          this.config.basePath + `/ta-desk/resend/domains/dns-records`,
          {
            headers: { Authorization: this.config.token },
            params: params ?? {},
          }
        );
      return results.data;
    },
  };
}
